import AppNavLink from '@/components/Router/AppNavLink';
import { AppRoutes, buildRoute } from '@/route/routeConfig';

interface IClientApplicationNavItems {
  name: 'Dashboard' | 'Client Applications';
  path: 'dashboard' | 'list';
}

const navPathToRouteKey: Record<IClientApplicationNavItems['path'], AppRoutes> = {
  dashboard: AppRoutes.ROVER_CLIENT_APPLICATIONS_DASHBOARD,
  list: AppRoutes.ROVER_CLIENT_APPLICATIONS_LIST,
};

const clientApplicationNavItems: IClientApplicationNavItems[] = [
  { name: 'Dashboard', path: 'dashboard' },
  { name: 'Client Applications', path: 'list' },
];

export default function ClientApplicationsNav() {
  return (
    <div className='flex flex-col w-full'>
      <div className='border-b border-neutralColor-light  mb-5 flex gap-8'>
        {clientApplicationNavItems.map((item: IClientApplicationNavItems) => (
          <AppNavLink
            key={item.name}
            to={buildRoute(navPathToRouteKey[item.path])}
            baseClassName='text-base px-2 font-semibold'
            activeClassName='border-primaryColor-normal text-primaryColor-normal border-b-2 pb-2'
          >
            {item.name}
          </AppNavLink>
        ))}
      </div>
    </div>
  );
}
